import React, { useState, useEffect, useRef } from 'react';
import {
  Box, Typography, Paper, Grid, Button, TextField, Select, MenuItem,
  FormControl, InputLabel, Chip, Avatar, Autocomplete, Switch,
  FormControlLabel, Dialog, DialogTitle, DialogContent, DialogActions,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  CircularProgress, Alert, Divider, Tooltip, IconButton, Pagination,
  ToggleButton, ToggleButtonGroup, Card, CardContent
} from '@mui/material';
import {
  Send, Preview, History, People, Star, Campaign,
  CardGiftcard, Notifications, Refresh, Close, CheckCircle,
  Person, Email as EmailIcon, AutoAwesome, ExpandMore
} from '@mui/icons-material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { adminService } from '../../services/api';

const EMAIL_TYPES = [
  { value: 'promotional', label: 'Promotionnel',  icon: <Campaign />,     color: '#3b82f6' },
  { value: 'gift',        label: 'Cadeau / Gift',  icon: <CardGiftcard />, color: '#f59e0b' },
  { value: 'announcement',label: 'Annonce',        icon: <Notifications />,color: '#8b5cf6' },
  { value: 'custom',      label: 'Personnalisé',   icon: <EmailIcon />,    color: '#64748b' },
];

const PRESET_TEMPLATES = [
  {
    type: 'promotional',
    label: '🎯 Offre spéciale',
    subject: '🎯 Offre exclusive ERA Project — Profitez-en maintenant !',
    content: `<h2 style="color:#1e293b;text-align:center;margin-bottom:8px;">Une offre rien que pour vous 🎯</h2>
<p style="color:#475569;text-align:center;font-size:16px;line-height:1.6;">Nous avons une offre exclusive réservée à nos utilisateurs fidèles.</p>
<div style="background:linear-gradient(135deg,#eff6ff,#dbeafe);border-radius:12px;padding:28px;text-align:center;margin:28px 0;">
  <p style="font-size:14px;color:#3b82f6;font-weight:600;margin:0 0 8px;">OFFRE LIMITÉE</p>
  <p style="font-size:40px;font-weight:900;color:#1e40af;margin:0 0 8px;">-30%</p>
  <p style="font-size:16px;color:#374151;margin:0;">sur l'abonnement annuel ERA Premium</p>
</div>
<p style="color:#475569;text-align:center;font-size:14px;">Utilisez le code <strong style="color:#2196F3;">ERA30</strong> lors de votre souscription. Offre valable jusqu'au <strong>31 décembre 2026</strong>.</p>
<div style="text-align:center;margin:28px 0;">
  <a href="https://app-era.groupeoctal.com/subscription" style="background:#2196F3;color:#fff;padding:14px 36px;text-decoration:none;border-radius:50px;font-weight:700;font-size:16px;display:inline-block;box-shadow:0 4px 12px rgba(33,150,243,0.35);">Profiter de l'offre</a>
</div>`,
  },
  {
    type: 'gift',
    label: '🎁 Cadeau Premium',
    subject: '🎁 Nous vous offrons un accès Premium ERA Project !',
    content: `<h2 style="color:#1e293b;text-align:center;margin-bottom:8px;">Un cadeau de notre part 🎁</h2>
<p style="color:#475569;text-align:center;font-size:16px;line-height:1.6;">En guise de remerciement pour votre fidélité, nous vous offrons un accès <strong>ERA Premium</strong> gratuit.</p>
<div style="background:linear-gradient(135deg,#fffbeb,#fef3c7);border:2px solid #f59e0b;border-radius:12px;padding:28px;text-align:center;margin:28px 0;">
  <p style="font-size:32px;margin:0 0 8px;">⭐</p>
  <p style="font-size:22px;font-weight:800;color:#92400e;margin:0 0 8px;">Accès Premium Offert</p>
  <p style="font-size:15px;color:#78350f;margin:0;">Projets illimités · IA · Support prioritaire</p>
</div>
<p style="color:#475569;text-align:center;font-size:14px;line-height:1.6;">Votre accès premium a été activé automatiquement sur votre compte. Connectez-vous pour en profiter.</p>
<div style="text-align:center;margin:28px 0;">
  <a href="https://app-era.groupeoctal.com/dashboard" style="background:#f59e0b;color:#fff;padding:14px 36px;text-decoration:none;border-radius:50px;font-weight:700;font-size:16px;display:inline-block;box-shadow:0 4px 12px rgba(245,158,11,0.35);">Accéder à ERA Premium</a>
</div>`,
  },
  {
    type: 'announcement',
    label: '📢 Nouvelle fonctionnalité',
    subject: '📢 Nouveauté ERA Project — Découvrez ce qui change !',
    content: `<h2 style="color:#1e293b;text-align:center;margin-bottom:8px;">Nouveauté sur ERA Project 📢</h2>
<p style="color:#475569;text-align:center;font-size:16px;line-height:1.6;">Notre équipe a travaillé dur pour vous apporter de nouvelles fonctionnalités.</p>
<div style="background:#f8fafc;border-left:4px solid #8b5cf6;border-radius:8px;padding:20px 24px;margin:24px 0;">
  <h3 style="color:#5b21b6;margin:0 0 12px;font-size:18px;">✨ Ce qui change</h3>
  <ul style="color:#475569;font-size:15px;line-height:2;margin:0;padding-left:20px;">
    <li>Nouvelle fonctionnalité 1</li>
    <li>Nouvelle fonctionnalité 2</li>
    <li>Amélioration des performances</li>
  </ul>
</div>
<div style="text-align:center;margin:28px 0;">
  <a href="https://app-era.groupeoctal.com/documentation" style="background:#8b5cf6;color:#fff;padding:14px 36px;text-decoration:none;border-radius:50px;font-weight:700;font-size:16px;display:inline-block;box-shadow:0 4px 12px rgba(139,92,246,0.35);">Découvrir les nouveautés</a>
</div>`,
  },
  {
    type: 'promotional',
    label: '⏰ Rappel d\'abonnement',
    subject: '⏰ Votre abonnement ERA expire bientôt — Renouvelez maintenant',
    content: `<h2 style="color:#1e293b;text-align:center;margin-bottom:8px;">Votre abonnement arrive à expiration ⏰</h2>
<p style="color:#475569;text-align:center;font-size:16px;line-height:1.6;">Ne perdez pas accès à toutes les fonctionnalités <strong>ERA Premium</strong> que vous utilisez au quotidien.</p>
<div style="background:#fff7ed;border:1px solid #fed7aa;border-radius:12px;padding:24px;text-align:center;margin:24px 0;">
  <p style="font-size:40px;margin:0 0 8px;">⚠️</p>
  <p style="font-size:18px;font-weight:700;color:#c2410c;margin:0;">Votre abonnement expire bientôt</p>
</div>
<p style="color:#475569;text-align:center;font-size:14px;line-height:1.6;">Renouvelez dès maintenant pour continuer à profiter de : Projets illimités, Vue Gantt avancée, Assistant IA, Support prioritaire.</p>
<div style="text-align:center;margin:28px 0;">
  <a href="https://app-era.groupeoctal.com/subscription" style="background:#ea580c;color:#fff;padding:14px 36px;text-decoration:none;border-radius:50px;font-weight:700;font-size:16px;display:inline-block;box-shadow:0 4px 12px rgba(234,88,12,0.35);">Renouveler mon abonnement</a>
</div>`,
  },
  {
    type: 'announcement',
    label: '👋 Message de bienvenue',
    subject: '👋 Bienvenue dans la communauté ERA Project !',
    content: `<h2 style="color:#1e293b;text-align:center;margin-bottom:8px;">Bienvenue dans la famille ERA 👋</h2>
<p style="color:#475569;text-align:center;font-size:16px;line-height:1.6;">Nous sommes ravis de vous compter parmi notre communauté grandissante d'utilisateurs ERA Project.</p>
<div style="background:#f0fdf4;border-radius:12px;padding:24px;margin:24px 0;">
  <p style="color:#166534;font-weight:700;font-size:16px;margin:0 0 12px;">🚀 Pour bien démarrer :</p>
  <ul style="color:#374151;font-size:15px;line-height:2;margin:0;padding-left:20px;">
    <li>Créez votre premier projet</li>
    <li>Invitez vos collaborateurs</li>
    <li>Explorez la vue Gantt et Kanban</li>
    <li>Testez l'assistant IA intégré</li>
  </ul>
</div>
<div style="text-align:center;margin:28px 0;">
  <a href="https://app-era.groupeoctal.com/dashboard" style="background:#16a34a;color:#fff;padding:14px 36px;text-decoration:none;border-radius:50px;font-weight:700;font-size:16px;display:inline-block;box-shadow:0 4px 12px rgba(22,163,74,0.35);">Commencer à utiliser ERA</a>
</div>`,
  },
];

const QUILL_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: [] }],
    ['link', 'image'],
    ['clean'],
  ],
};

const QUILL_FORMATS = [
  'header', 'bold', 'italic', 'underline', 'strike',
  'color', 'background', 'list', 'bullet', 'align',
  'link', 'image',
];

const PLAN_LABELS = { monthly: 'Mensuel (30 j)', annual: 'Annuel (365 j)' };

function RecipientBadge({ count }) {
  return (
    <Chip
      icon={<People fontSize="small" />}
      label={count !== null ? `${count} destinataire${count > 1 ? 's' : ''}` : '…'}
      size="small"
      color={count > 0 ? 'primary' : 'default'}
      sx={{ fontWeight: 'bold' }}
    />
  );
}

export default function AdminEmailTab() {
  // ── Form state ──
  const [emailType,      setEmailType]      = useState('custom');
  const [subject,        setSubject]        = useState('');
  const [content,        setContent]        = useState('');
  const [recipientMode,  setRecipientMode]  = useState('all');   // all | specific | filter
  const [selectedUsers,  setSelectedUsers]  = useState([]);
  const [filterRole,     setFilterRole]     = useState('');
  const [filterHasSub,   setFilterHasSub]   = useState('');
  const [grantPremium,   setGrantPremium]   = useState(false);
  const [premiumPlan,    setPremiumPlan]    = useState('monthly');
  const [premiumDays,    setPremiumDays]    = useState(30);

  // ── UI state ──
  const [userOptions,    setUserOptions]    = useState([]);
  const [userLoading,    setUserLoading]    = useState(false);
  const [sending,        setSending]        = useState(false);
  const [alert,          setAlert]          = useState({ type: '', text: '' });
  const [previewOpen,    setPreviewOpen]    = useState(false);
  const [historyTab,     setHistoryTab]     = useState(false);

  // ── History state ──
  const [history,        setHistory]        = useState([]);
  const [historyTotal,   setHistoryTotal]   = useState(0);
  const [historyPage,    setHistoryPage]    = useState(1);
  const [historyLoading, setHistoryLoading] = useState(false);

  const searchTimer = useRef(null);

  const showAlert = (type, text) => {
    setAlert({ type, text });
    setTimeout(() => setAlert({ type: '', text: '' }), 5000);
  };

  // ── User search for Autocomplete ──
  const handleUserSearch = (_, value) => {
    clearTimeout(searchTimer.current);
    if (!value) { setUserOptions([]); return; }
    searchTimer.current = setTimeout(async () => {
      setUserLoading(true);
      try {
        const r = await adminService.searchEmailUsers(value);
        setUserOptions(r.data.users || []);
      } catch (_) {}
      setUserLoading(false);
    }, 300);
  };

  // ── Load history ──
  const loadHistory = async (page = 1) => {
    setHistoryLoading(true);
    try {
      const r = await adminService.getEmailHistory({ page, limit: 15 });
      setHistory(r.data.logs || []);
      setHistoryTotal(r.data.total || 0);
      setHistoryPage(page);
    } catch (_) {}
    setHistoryLoading(false);
  };

  useEffect(() => { if (historyTab) loadHistory(1); }, [historyTab]);

  // ── Recipient count estimate ──
  const recipientCount = recipientMode === 'specific' ? selectedUsers.length : null;

  // ── Build payload ──
  const buildPayload = () => ({
    subject,
    content,
    type: emailType,
    recipient_type: recipientMode,
    recipient_ids: recipientMode === 'specific' ? selectedUsers.map(u => u.id) : undefined,
    recipient_filter: recipientMode === 'filter' ? { role: filterRole, hasSub: filterHasSub } : undefined,
    grant_premium: grantPremium,
    premium_days:  grantPremium ? premiumDays  : undefined,
    premium_plan:  grantPremium ? premiumPlan  : undefined,
  });

  // ── Send ──
  const handleSend = async () => {
    if (!subject.trim()) return showAlert('error', 'Veuillez saisir un sujet.');
    if (!content.replace(/<[^>]*>/g, '').trim()) return showAlert('error', 'Le contenu est vide.');
    if (recipientMode === 'specific' && !selectedUsers.length) return showAlert('error', 'Sélectionnez au moins un destinataire.');
    setSending(true);
    try {
      const r = await adminService.sendEmail(buildPayload());
      showAlert('success', r.data.message);
      if (historyTab) loadHistory(1);
    } catch (err) {
      showAlert('error', err.response?.data?.error || 'Erreur lors de l\'envoi.');
    }
    setSending(false);
  };

  const typeInfo = EMAIL_TYPES.find(t => t.value === emailType) || EMAIL_TYPES[3];
  const formatDate = d => d ? new Date(d).toLocaleString('fr-FR') : '-';

  // ───────────────────────────────────────────────────────────────────────────
  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Campaign color="primary" /> Emails Marketing
        </Typography>
        <ToggleButtonGroup size="small" value={historyTab ? 'history' : 'compose'}
          exclusive onChange={(_, v) => v !== null && setHistoryTab(v === 'history')}>
          <ToggleButton value="compose"><EmailIcon fontSize="small" sx={{ mr: 0.5 }} />Composer</ToggleButton>
          <ToggleButton value="history"><History fontSize="small" sx={{ mr: 0.5 }} />Historique</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {alert.text && <Alert severity={alert.type} sx={{ mb: 2 }} onClose={() => setAlert({ type: '', text: '' })}>{alert.text}</Alert>}

      {/* ══════════════ COMPOSER ══════════════ */}
      {!historyTab && (
        <Grid container spacing={3}>
          {/* ── Colonne gauche : configuration ── */}
          <Grid item xs={12} md={4}>
            <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
              <Typography variant="subtitle2" fontWeight="bold" gutterBottom>Type d'email</Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 3 }}>
                {EMAIL_TYPES.map(t => (
                  <Chip
                    key={t.value}
                    icon={t.icon}
                    label={t.label}
                    clickable
                    onClick={() => setEmailType(t.value)}
                    sx={{
                      borderWidth: 2,
                      borderStyle: 'solid',
                      borderColor: emailType === t.value ? t.color : 'transparent',
                      bgcolor: emailType === t.value ? t.color + '18' : undefined,
                      color: emailType === t.value ? t.color : undefined,
                      fontWeight: emailType === t.value ? 'bold' : 'normal',
                    }}
                  />
                ))}
              </Box>

              <Divider sx={{ mb: 2 }} />

              <Typography variant="subtitle2" fontWeight="bold" gutterBottom>Destinataires</Typography>
              <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                <InputLabel>Mode</InputLabel>
                <Select value={recipientMode} label="Mode" onChange={e => setRecipientMode(e.target.value)}>
                  <MenuItem value="all"><em>Tous les utilisateurs actifs</em></MenuItem>
                  <MenuItem value="specific">Sélection manuelle</MenuItem>
                  <MenuItem value="filter">Filtrer par critères</MenuItem>
                </Select>
              </FormControl>

              {recipientMode === 'specific' && (
                <Autocomplete
                  multiple
                  size="small"
                  options={userOptions}
                  loading={userLoading}
                  getOptionLabel={o => `${o.full_name} (${o.email})`}
                  isOptionEqualToValue={(o, v) => o.id === v.id}
                  value={selectedUsers}
                  onChange={(_, v) => setSelectedUsers(v)}
                  onInputChange={handleUserSearch}
                  renderInput={params => (
                    <TextField {...params} label="Rechercher des utilisateurs" placeholder="Nom ou email…"
                      InputProps={{ ...params.InputProps,
                        endAdornment: (<>{userLoading ? <CircularProgress size={16} /> : null}{params.InputProps.endAdornment}</>)
                      }}
                    />
                  )}
                  renderTags={(v, getTagProps) =>
                    v.map((opt, i) => (
                      <Chip key={opt.id} {...getTagProps({ index: i })}
                        avatar={<Avatar sx={{ width: 20, height: 20, fontSize: '0.6rem' }}>{opt.full_name?.charAt(0)}</Avatar>}
                        label={opt.full_name} size="small"
                      />
                    ))
                  }
                  sx={{ mb: 2 }}
                />
              )}

              {recipientMode === 'filter' && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 2 }}>
                  <FormControl size="small" fullWidth>
                    <InputLabel>Rôle</InputLabel>
                    <Select value={filterRole} label="Rôle" onChange={e => setFilterRole(e.target.value)}>
                      <MenuItem value="">Tous</MenuItem>
                      <MenuItem value="user">User</MenuItem>
                      <MenuItem value="admin">Admin</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl size="small" fullWidth>
                    <InputLabel>Abonnement</InputLabel>
                    <Select value={filterHasSub} label="Abonnement" onChange={e => setFilterHasSub(e.target.value)}>
                      <MenuItem value="">Tous</MenuItem>
                      <MenuItem value="yes">Avec abonnement actif</MenuItem>
                      <MenuItem value="no">Sans abonnement actif</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              )}

              <RecipientBadge count={recipientCount} />

              <Divider sx={{ my: 2 }} />

              {/* Premium Gift */}
              <Box sx={{ bgcolor: grantPremium ? 'warning.50' : undefined, borderRadius: 2, p: grantPremium ? 1.5 : 0, border: grantPremium ? '1px solid' : 'none', borderColor: 'warning.200', transition: 'all .2s' }}>
                <FormControlLabel
                  control={<Switch checked={grantPremium} onChange={e => setGrantPremium(e.target.checked)} color="warning" />}
                  label={<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}><Star fontSize="small" color="warning" /><Typography variant="body2" fontWeight="bold">Accorder accès premium</Typography></Box>}
                />
                {grantPremium && (
                  <Box sx={{ mt: 1.5, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                    <FormControl size="small" fullWidth>
                      <InputLabel>Plan</InputLabel>
                      <Select value={premiumPlan} label="Plan" onChange={e => setPremiumPlan(e.target.value)}>
                        <MenuItem value="monthly">Mensuel</MenuItem>
                        <MenuItem value="annual">Annuel</MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                      size="small" fullWidth type="number"
                      label="Durée (jours)" value={premiumDays}
                      onChange={e => setPremiumDays(Math.max(1, parseInt(e.target.value) || 1))}
                      inputProps={{ min: 1 }}
                      helperText={`Expiration dans ${premiumDays} jour${premiumDays > 1 ? 's' : ''}`}
                    />
                  </Box>
                )}
              </Box>
            </Paper>
          </Grid>

          {/* ── Colonne droite : éditeur ── */}
          <Grid item xs={12} md={8}>
            <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2, height: '100%' }}>

              {/* Templates prédéfinis */}
              <Accordion variant="outlined" sx={{ mb: 2, borderRadius: '8px !important', '&:before': { display: 'none' } }}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <AutoAwesome fontSize="small" color="primary" />
                    <Typography variant="subtitle2" fontWeight="bold">Templates prédéfinis</Typography>
                    <Chip label={PRESET_TEMPLATES.length} size="small" color="primary" sx={{ height: 18, fontSize: '0.65rem' }} />
                  </Box>
                </AccordionSummary>
                <AccordionDetails sx={{ pt: 0 }}>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {PRESET_TEMPLATES.map((tpl, i) => {
                      const typeInfo = EMAIL_TYPES.find(t => t.value === tpl.type) || EMAIL_TYPES[3];
                      return (
                        <Chip
                          key={i}
                          label={tpl.label}
                          clickable
                          onClick={() => {
                            setEmailType(tpl.type);
                            setSubject(tpl.subject);
                            setContent(tpl.content);
                          }}
                          sx={{
                            bgcolor: typeInfo.color + '15',
                            color: typeInfo.color,
                            border: `1px solid ${typeInfo.color}40`,
                            fontWeight: 500,
                            fontSize: '0.8rem',
                            '&:hover': { bgcolor: typeInfo.color + '28' },
                          }}
                        />
                      );
                    })}
                  </Box>
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                    Cliquez sur un template pour le charger dans l'éditeur. Vous pouvez ensuite le personnaliser.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <TextField
                fullWidth label="Objet de l'email" value={subject}
                onChange={e => setSubject(e.target.value)}
                placeholder="Ex: 🎉 Offre spéciale pour vous !"
                sx={{ mb: 2 }}
              />

              <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>Contenu</Typography>
              <Box sx={{
                '& .ql-container': { fontSize: '14px', minHeight: 280, borderRadius: '0 0 8px 8px' },
                '& .ql-toolbar': { borderRadius: '8px 8px 0 0', bgcolor: 'background.default' },
                mb: 2
              }}>
                <ReactQuill
                  theme="snow"
                  value={content}
                  onChange={setContent}
                  modules={QUILL_MODULES}
                  formats={QUILL_FORMATS}
                  placeholder="Rédigez votre message ici. Vous pouvez ajouter du texte enrichi, des images, des liens…"
                />
              </Box>

              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                <Button variant="outlined" startIcon={<Preview />} onClick={() => setPreviewOpen(true)}
                  disabled={!content.replace(/<[^>]*>/g, '').trim()}>
                  Prévisualiser
                </Button>
                <Button variant="contained" startIcon={sending ? <CircularProgress size={16} color="inherit" /> : <Send />}
                  onClick={handleSend} disabled={sending} color="primary">
                  {sending ? 'Envoi en cours…' : 'Envoyer'}
                </Button>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      )}

      {/* ══════════════ HISTORIQUE ══════════════ */}
      {historyTab && (
        <Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <IconButton onClick={() => loadHistory(historyPage)}><Refresh /></IconButton>
          </Box>
          {historyLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}><CircularProgress /></Box>
          ) : (
            <>
              <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell>Sujet</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Destinataires</TableCell>
                      <TableCell>Premium</TableCell>
                      <TableCell>Envoyé par</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {history.map(log => {
                      const typeInfo = EMAIL_TYPES.find(t => t.value === log.type) || EMAIL_TYPES[3];
                      return (
                        <TableRow key={log.id} hover>
                          <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatDate(log.created_at)}</TableCell>
                          <TableCell sx={{ maxWidth: 250 }}>
                            <Typography variant="body2" noWrap fontWeight="medium">{log.subject}</Typography>
                          </TableCell>
                          <TableCell>
                            <Chip label={typeInfo.label} size="small"
                              sx={{ bgcolor: typeInfo.color + '18', color: typeInfo.color, fontWeight: 'bold', fontSize: '0.7rem' }} />
                          </TableCell>
                          <TableCell>
                            <Tooltip title={log.recipients_emails || ''} placement="top">
                              <Chip icon={<People fontSize="small" />} label={log.recipients_count} size="small" />
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            {log.premium_granted ? (
                              <Tooltip title={`${PLAN_LABELS[log.premium_plan] || log.premium_plan} — ${log.premium_days} jours`}>
                                <Chip icon={<Star fontSize="small" />} label="Oui" size="small" color="warning" />
                              </Tooltip>
                            ) : (
                              <Typography variant="caption" color="text.secondary">—</Typography>
                            )}
                          </TableCell>
                          <TableCell>
                            <Typography variant="caption">{log.sent_by_name || '—'}</Typography>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {!history.length && (
                      <TableRow>
                        <TableCell colSpan={6} align="center" sx={{ py: 5, color: 'text.secondary' }}>
                          Aucun email envoyé pour l'instant
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Pagination count={Math.ceil(historyTotal / 15)} page={historyPage}
                  onChange={(_, p) => loadHistory(p)} />
              </Box>
            </>
          )}
        </Box>
      )}

      {/* ══════════════ DIALOG PREVIEW ══════════════ */}
      <Dialog open={previewOpen} onClose={() => setPreviewOpen(false)} maxWidth="md" fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Preview color="primary" />
            <span>Aperçu de l'email</span>
          </Box>
          <IconButton onClick={() => setPreviewOpen(false)} size="small"><Close /></IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ p: 0 }}>
          {/* Email envelope header */}
          <Box sx={{ bgcolor: 'grey.50', px: 3, py: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
            <Typography variant="caption" color="text.secondary">De :</Typography>
            <Typography variant="body2" sx={{ ml: 1, display: 'inline' }}>ERA Project &lt;noreply@groupeoctal.com&gt;</Typography>
            <br />
            <Typography variant="caption" color="text.secondary">Objet :</Typography>
            <Typography variant="body2" fontWeight="bold" sx={{ ml: 1, display: 'inline' }}>{subject || '(sans objet)'}</Typography>
          </Box>

          {/* Rendered email template */}
          <Box sx={{ p: 3, bgcolor: '#f4f4f5' }}>
            <Box sx={{
              maxWidth: 600, mx: 'auto', bgcolor: '#fff', borderRadius: 2,
              boxShadow: '0 4px 20px rgba(0,0,0,0.08)', overflow: 'hidden'
            }}>
              {/* ERA Header */}
              <Box sx={{ textAlign: 'center', px: 3, py: 3, borderBottom: '1px solid #f0f0f0' }}>
                <Typography component="span" sx={{ fontSize: '1.6rem', fontWeight: 800, color: '#2196F3' }}>
                  ERA<span style={{ color: '#1e293b' }}>PROJECT</span>
                </Typography>
              </Box>
              {/* Body */}
              <Box sx={{ px: 4, py: 4 }}
                dangerouslySetInnerHTML={{ __html: content }}
              />
              {/* Footer */}
              <Box sx={{ textAlign: 'center', px: 3, py: 2.5, bgcolor: '#f8fafc', borderTop: '1px solid #f0f0f0' }}>
                <Typography variant="caption" color="text.secondary" display="block">ERA Project</Typography>
                <Typography variant="caption" color="text.secondary">
                  &copy; {new Date().getFullYear()} ERA Project. Tous droits réservés.
                </Typography>
              </Box>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setPreviewOpen(false)}>Fermer</Button>
          <Button variant="contained" startIcon={<Send />}
            onClick={() => { setPreviewOpen(false); handleSend(); }}>
            Envoyer maintenant
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
